export default "https://legacy.eskolare-development.com/images/collection.png";